var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"px-5 transparent",attrs:{"fluid":""}},[_c('div',{staticClass:"site-width"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }